export const API_KEY = 'nhEAeubCSI57GS2pbE5CzllVrXQ9IRzKwU4wDn2EkWZFqnsk1T';
export const API_URL = 'https://api.tumblr.com/v2/blog/';
export const POSTS_PER_PAGE = 50;
